<script lang="ts">
	import cn from 'classnames';
	import { onMount } from 'svelte';
	import { classList } from 'svelte-body';

	import { bodyClass, globalStore } from '@components/stores';

	import '$lib/styles/design-tokens.css';
	import s from './(main)/[[lang=lang]]/layout.module.css';

    import { page } from '$app/stores';

    let component: import('svelte').ComponentType | null = null;
    let code = '';
    let message = '';
    let country = '';
    let isDesktopSite = false;
    let isGeoBlocked = false;

    let LL = {
        error: {
            metaTitle: ({ code: _code }: { code: string }) => `Error ${_code}`,
            metaDescription: ({ message: _message }: { message: string }) => _message,
        },
    };

    onMount(async () => {
        const error = $page.error;

        code = error?.code?.toString() ?? '';
        message = error?.message ?? '';
        country = error?.geoBlockCountry ?? '';
        isDesktopSite = error?.isDesktopSite ?? false;
        isGeoBlocked = error?.code === 403 && error?.cause === 'geoBlocked';

        const { getErrorComponent } = await import('$lib/components/error');
        component = getErrorComponent(error?.code, error?.cause);

        try {
            const [{ loadLocaleAsync }, { setLocale, LL: _LL }] = await Promise.all([
                import('@i18n/i18n-util.async'),
                import('@i18n/i18n-svelte'),
            ]);
            await loadLocaleAsync('en');
            setLocale('en');
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            LL = _LL;
        } catch (e) {
            console.warn('i18n failed to load', e);
        }

        if (message && !message.includes('Not found') && !country) {
            try {
                const Sentry = await import('@sentry/sveltekit?inline');
                Sentry.captureException(new Error(message || 'Unknown error'), {
                    contexts: {
                        errorInfo: { code, message, expected: false },
                    },
                });
            } catch (e) {
                console.warn('Sentry failed to load', e);
            }
        }

        // store только при geoBlock
        if (country) {
            try {
                globalStore.setGeoBlocked(country);
                globalStore.switchToDesktop(isDesktopSite);
            } catch (e) {
                console.warn('Store failed to load', e);
            }
        }
    });
</script>

<svelte:head>
	<title>{isGeoBlocked
	    ? `Service is temporarily unavailable in ${country}`
	    : (LL?.error?.metaTitle ? LL.error.metaTitle({ code }) : `Error ${code}`)}
    </title>
	<meta name="description" content={LL?.error?.metaDescription
	    ? LL.error.metaDescription({ message })
	    : message || 'Error'}
    />
</svelte:head>

<svelte:body use:classList={cn({ [s.desktop]: $globalStore.isDesktopSite }, $bodyClass)} />

{#if component}
    {#if isGeoBlocked}
		{#await import('@components/layout/main-wrapper') then mod}
			<svelte:component this={mod.MainWrapper}>
				<svelte:component this={component} {code} {country} />
			</svelte:component>
		{:catch}
			<svelte:component this={component} {code} {country} />
		{/await}
	{:else}
		<svelte:component this={component} {code} {country} />
	{/if}
{/if}
